module.exports = __webpack_public_path__ + "img/bttn_gift_complete.6ece9f30.png";